import React, { useMemo, useState } from "react";
import { Grid, Button } from "@mui/material";
import {
  Publish,
  GetApp,
  ArrowDropDownCircleOutlined,
} from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";

import OptionList from "./OptionList";
import OptionPopUp from "./OptionPopUp";
import { useAxios } from "../../../../hooks";
import uploadToS3 from "../../../../utils/uploadToS3";
import { Paper, ComponentHeader } from "../../../../components";

export default function DropDownTableControl({ formikProps, editState }) {
  const axios = useAxios();

  const [addOptionPopUp, setAddOptionPopUp] = useState({
    state: false,
    mode: "add",
    data: {
      id: "",
      label: "",
    },
  });

  const [loading, setLoading] = useState(false);

  const downloadDummyCSV = () => {
    window.location.href =
      "https://static-assets-dc.s3.ap-south-1.amazonaws.com/sample_data_files/sample_options_format.xlsx";
  };

  const handleUploadFile = (CSV) => {
    const file = CSV.target.files[0];
    const reader = new FileReader();

    if (file) {
      reader.readAsDataURL(file);
      reader.onload = function () {
        const uploadBucket = {
          name: "adn-media",
          region: "ap-south-1",
          identityPoolID: "ap-south-1:e58786e7-9711-4dea-a2e2-7d9c10e38333",
        };

        uploadToS3({
          bucket: uploadBucket,
          filePath: "sample_data_files/" + file.name,
          file,
          bucketRegion: "ap-south-1",
        }).then(function (data) {
          setLoading(false);
          var option = {
            file:
              "https://" +
              uploadBucket.name +
              ".s3.ap-south-1.amazonaws.com/sample_data_files/" +
              file.name,
          };

          axios({
            url: "/custom_fields/get_excel_data_from_url",
            method: "POST",
            data: option,
            disableRedirect: true,
          }).then((response) => {
            if (response.status) {
              setLoading(false);
              formikProps.setValues((prevVal) => {
                let newOptions = [...prevVal.options];
                for (var option of response.data) {
                  newOptions.push({ ...option, is_active: true });
                }
                return {
                  ...prevVal,
                  options: newOptions,
                };
              });
            }
          });
        });
      };
      reader.onerror = function (error) {
        console.error("Error: ", error);
      };
    }
  };

  const handleAddNewOption = () => {
    setAddOptionPopUp({
      state: true,
      mode: "add",
      data: {
        id: "",
        label: "",
      },
    });
  };

  return (
    <Paper>
      <Grid size={12}>
        <ComponentHeader
          title="Upload Dropdown Options"
          subtitle="Upload Options for your dropdown."
          buttons={[
            <Button
              disabled={!editState}
              variant="outlined"
              color="primary"
              onClick={downloadDummyCSV}
            >
              <GetApp /> &nbsp; Download Sample Format
            </Button>,

            <Button
              onClick={handleAddNewOption}
              variant="outlined"
              color="primary"
              component="span"
              disabled={!editState}
            >
              <ArrowDropDownCircleOutlined />
              &nbsp; Add New Option
            </Button>,
          ]}
        />
      </Grid>

      <Grid item>
        <label htmlFor="contained-button-file">
          <input
            style={{ display: "none" }}
            id="contained-button-file"
            multiple
            type="file"
            onClick={(e) => {
              e.target.value = null;
            }}
            disabled={!editState}
            onChange={(event) => handleUploadFile(event)}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />

          <LoadingButton
            loading={loading}
            loadingPosition="start"
            startIcon={<Publish />}
            disabled={!editState}
            variant="outlined"
            component="span"
          >
            Upload Options
          </LoadingButton>
        </label>
      </Grid>

      <Grid size={12}>
        <OptionList
          editState={editState}
          list={formikProps?.values?.options}
          formikProps={formikProps}
        />
      </Grid>

      <OptionPopUp
        addOptionPopUp={addOptionPopUp}
        setAddOptionPopUp={setAddOptionPopUp}
        formikProps={formikProps}
      />
    </Paper>
  );
}
